import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ProfileService } from '../services/profile.service';


@Injectable({ providedIn: 'root' })
export class MfaGuard implements CanActivate {

  constructor(
    private readonly router: Router,
    private readonly profileService: ProfileService
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (sessionStorage.getItem('cellVerificationDone') === 'true') {
      return of(true);
    }

    return this.profileService.userProfile().pipe(
      map((data: any) => {
        if (data?.cellNumberVerifiedByUser || !data?.phoneNumber) {
          this.profileService.markCellVerificationDone();
          return true;
        }

        sessionStorage.setItem('mfaReturnUrl', state.url.split('#')[0]);
        this.router.navigate(['/authenticate'], { replaceUrl: true });
        return false;
      }),
      catchError(() => {
        this.router.navigate(['/login'], { replaceUrl: true });
        return of(false);
      })
    );
  }
}
